<template>
  <div class="cal-entry-dialog">
    <form novalidate class="md-layout">
      <md-card  style="min-width:560px;">
        <md-card-header>
          <b-row>
            <b-col md="6" lg="10">
              <div class="md-title">{{propertyTitle}}</div>
            </b-col>
            <b-col md="6" lg="2" style="text-align:right">
              <md-button class="md-icon-button md-dense" @click="$emit('closed')">
                <md-icon>highlight_off</md-icon>
              </md-button>
            </b-col>
          </b-row>
        </md-card-header>
        <md-card-content>
          <md-tabs class="white">
            <md-tab id="general-tab" md-label="General">
              <!--TODO: separate component-->
              <b-row class="mb-3">
                <b-col>
                  <md-chip class="md-primary">{{ eventType }}</md-chip>
                </b-col>
                <b-col>
                  <md-button v-if="dealId" @click="goToDeal()" class="md-primary m-0">
                    <md-icon>bookmarks</md-icon>Go To Deal
                  </md-button>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <md-field>
                    <label>Tenant name</label>
                    <md-input placeholder="Name" v-model="tenantName" required :disabled="readOnly"></md-input>
                  </md-field>
                </b-col>
                <b-col>
                  <md-field>
                    <label>Tenant surname</label>
                    <md-input
                      placeholder="Surname"
                      v-model="tenantSurname"
                      required
                      :disabled="readOnly"
                    ></md-input>
                  </md-field>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <md-datepicker
                    v-model="startDate"
                    :class="messageClass"
                    :md-disabled-dates="disabledStartDates"
                    md-immediately
                    :disabled="readOnly"
                  >
                    <label>Start date</label>
                    <span class="md-error">Selected period conflicts with other entries</span>
                  </md-datepicker>
                </b-col>
                <b-col>
                  <md-datepicker
                    v-if="!termless"
                    v-model="endDate"
                    :class="messageClass"
                    :disabled="!termless || readOnly"
                    :md-disabled-dates="disabledEndDates"
                    md-immediately
                  >
                    <label>End date</label>
                    <span class="md-error">Selected period conflicts with other entries</span>
                  </md-datepicker>
                  <md-field v-else>
                    <label>Disabled</label>
                    <md-input placeholder="Entry is termless" disabled></md-input>
                  </md-field>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <md-field>
                    <label for="bookingStatus">Entry status</label>
                    <md-select v-model="bookingStatus" id="bookingStatus" :disabled="readOnly">
                      <md-option
                        v-for="(status, index) in bookingStatuses"
                        :key="index"
                        :value="status.value"
                      >{{ status.title }}</md-option>
                    </md-select>
                  </md-field>
                </b-col>
                <b-col>
                  <md-checkbox
                    v-model="termless"
                    class="md-primary"
                    :disabled="readOnly"
                  >Termless entry</md-checkbox>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <md-field>
                    <label>Event Description</label>
                    <md-textarea v-model="statusComment" :disabled="readOnly"></md-textarea>
                  </md-field>
                </b-col>
              </b-row>
            </md-tab>
            <md-tab id="deals-tab" md-label="Deal Notes" :md-disabled="!dealNotesAvailable">
              <!--<md-progress-bar md-mode="indeterminate"></md-progress-bar>-->
              <listing-deal-notes
                v-if="dealNotesAvailable"
                :deal-id="dealId"
                :account-id="selectedAccountId"
              ></listing-deal-notes>
              <p v-else>Notes are not available for this kind of Deal</p>
            </md-tab>
          </md-tabs>
        </md-card-content>

        <md-card-actions v-if="!readOnly">
          <md-button
            class="md-button btn-danger"
            @click="deleteConfirmationModalOpened = true"
          >Delete</md-button>
          <md-button class="md-button" @click="$emit('closed')">Cancel</md-button>
          <md-progress-spinner
            v-if="loading"
            :md-diameter="30"
            :md-stroke="3"
            md-mode="indeterminate"
            style="color:white"
          ></md-progress-spinner>
          <md-button
            :disabled="!isFormValid || loading"
            class="md-primary"
            @click="onCheckAvailability"
          >Update</md-button>
        </md-card-actions>
      </md-card>
    </form>

    <md-dialog :md-active.sync="deleteConfirmationModalOpened">
      <div>
        <form novalidate class="md-layout">
          <md-card style="min-width: 400px;">
            <md-card-header>
              <b-row>
                <b-col>
                  <div class="md-title">Are you sure?</div>
                </b-col>
                <b-col style="text-align:right">
                  <md-button
                    class="md-icon-button md-dense"
                    @click="deleteConfirmationModalOpened = false"
                  >
                    <md-icon>highlight_off</md-icon>
                  </md-button>
                </b-col>
              </b-row>
            </md-card-header>
            <md-card-content>
              <b-row>
                <b-col>
                  <p>Are you sure you want to delete this record?</p>
                </b-col>
              </b-row>
            </md-card-content>
            <md-card-actions>
              <md-button class="md-button btn-danger" @click="onDeleteEntry">Yes</md-button>
              <md-button class="md-button" @click="deleteConfirmationModalOpened = false">Cancel</md-button>
            </md-card-actions>
          </md-card>
        </form>
      </div>
    </md-dialog>

    <event-overlapping-confirmation-dialog
      v-model="eventOverlappingConfirmationDialogOpened"
      @confirmed="onUpdateEntry"
    ></event-overlapping-confirmation-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import EventOverlappingConfirmationDialog from "@/components/property-calendar/dialogs/EventOverlappingConfirmationDialog.vue";
import ListingDealNotes from "@/components/listingDealNotes.vue";

export default {
  name: "EditEntryDialog",
  components: { EventOverlappingConfirmationDialog, ListingDealNotes },
  props: {
    propertyId: {
      type: String,
      required: true
    },
    entryId: {
      type: String,
      required: true
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  created() {
    if (!this.entry) {
      return;
    }
    this.startDate = this.entry.startDate ? new Date(this.entry.startDate) : "";
    this.endDate = this.entry.endDate ? new Date(this.entry.endDate) : "";
    this.bookingStatus = this.entry.status;
    this.statusComment = this.entry.statusComment;
    this.termless = this.entry.termless;
    this.tenantName = this.entry.tenantName;
    this.tenantSurname = this.entry.tenantSurname;
  },
  data() {
    return {
      startDate: null,
      endDate: null,
      bookingStatuses: [
        {
          title: "Pre-booked",
          value: "prebooked"
        },
        {
          title: "Booked",
          value: "booked"
        },
        {
          title: "Blocked",
          value: "blocked"
        }
      ],
      bookingStatus: "",
      statusComment: "",
      termless: false,
      loading: false,
      deleteConfirmationModalOpened: false,
      selectedDatesAvailable: true,
      tenantName: "",
      tenantSurname: "",
      eventOverlappingConfirmationDialogOpened: false
    };
  },
  computed: {
    ...mapState({
      activeProperties: state => state.propertiesModule.activeProperties,
      draftProperties: state => state.propertiesModule.draftProperties
    }),
    ...mapState("propertyCalendarModule", ["entries"]),
    entryTitle() {
      if (this.systemGeneratedEntry) return "View Only (auto generated entry)";
      else return "Calendar entry";
    },
    property() {
      var res = this.activeProperties.find(
        item => item._id === this.propertyId
      );
      if (res) return res;
      else
        return this.draftProperties.find(item => item._id === this.propertyId);
    },
    entry() {
      return this.entries.find(item => item.id === this.entryId);
    },
    propertyTitle() {
      console.log("property:", this.property);

      if (!this.property || !this.property._id) {
        return null;
      }
      try {
        const {
          location: {
            address: { street, number, apartNumber, municipality } = {}
          } = {}
        } = this.property;

        return `${street} ${number} - ${apartNumber}, ${municipality}`;
      } catch (error) {
        console.log(error);
        return "";
      }
    },
    isFormValid() {
      return this.datesValid && this.bookingStatus && this.tenantPresent;
    },
    tenantPresent() {
      if (this.bookingStatus === "blocked") {
        return true;
      }

      return this.tenantName && this.tenantSurname;
    },
    datesValid() {
      return this.startDate && (this.endDate || this.termless);
    },
    messageClass() {
      return {
        "md-invalid": !this.selectedDatesAvailable
      };
    },
    systemGeneratedEntry() {
      return this.entry.creatorType === "system";
    },
    readOnly() {
      return this.systemGeneratedEntry || this.readonly;
    },
    dealId() {
      if (!this.entry || !this.entry.id) {
        return null;
      }
      return this.entry.bookingId;
    },
    selectedAccountId() {
      return this.$store.getters.connectedAccountIds.length > 0
        ? this.$store.getters.connectedAccountIds[0]
        : null;
    },
    dealNotesAvailable() {
      return this.dealId && this.selectedAccountId;
    },
    eventType() {
      if (this.systemGeneratedEntry) return "Auto entry";
      else return "Manual entry";
    }
  },
  methods: {
    ...mapActions("propertyCalendarModule", [
      "updateEntry",
      "rewriteEntry",
      "deleteEntry",
      "checkAvailability"
    ]),
    disabledStartDates(date) {
      if (!this.endDate) {
        return false;
      }

      return date.getTime() > this.endDate.getTime();
    },
    disabledEndDates(date) {
      if (!this.startDate) {
        return false;
      }

      return date.getTime() < this.startDate.getTime();
    },
    resetData() {
      this.startDate = null;
      this.endDate = null;
      this.bookingStatus = "";
      this.statusComment = "";
      this.termless = false;
      this.selectedDatesAvailable = true;
      this.tenantName = "";
      this.tenantSurname = "";
      this.eventOverlappingConfirmationDialogOpened = false;
    },
    notifyUser(title, msg) {
      this.$notify({
        title: title,
        message: msg
      });
    },
    async onCheckAvailability() {
      try {
        this.loading = true;
        const available = await this.checkAvailability({
          propertyId: this.propertyId,
          entryId: this.entryId,
          startDate: this.startDate,
          endDate: this.endDate,
          termless: this.termless
        });
        if (!available) {
          this.selectedDatesAvailable = false;
          this.eventOverlappingConfirmationDialogOpened = true;
          return;
        }
        this.selectedDatesAvailable = true;
        await this.onUpdateEntry();
      } catch (error) {
        this.notifyUser("Server error", "Something is not right");
      } finally {
        this.loading = false;
      }
    },
    async onUpdateEntry() {
      try {
        this.loading = true;
        const payload = {
          id: this.entryId,
          propertyId: this.propertyId,
          startDate: this.startDate,
          creatorType: this.creatorType,
          endDate: this.endDate,
          termless: this.termless,
          bookingStatus: this.bookingStatus,
          bookingId: this.dealId || null,
          status: this.bookingStatus,
          statusComment: this.statusComment,
          tenantName: this.tenantName,
          tenantSurname: this.tenantSurname
        };
        this.rewriteEntry({ entryId: this.entryId, payload });
        this.$emit("closed");
        await this.updateEntry({ entryId: this.entryId, payload });
        this.resetData();
      } catch (error) {
        this.notifyUser("Server error", "Something is not right");
      } finally {
        this.loading = false;
      }
    },
    async onDeleteEntry() {
      try {
        this.deleteConfirmationModalOpened = false;
        await this.deleteEntry(this.entryId);
        this.$emit("closed");
        this.resetData();
      } catch (error) {
        this.notifyUser("Server error", "Something is not right");
      } finally {
        this.loading = true;
      }
    },
    goToDeal() {
      if (this.dealId) {
        this.navigateTo({ name: "deal", params: { dealId: this.dealId } });
      }
    },
    navigateTo({ name, params, query }) {
      this.$router.push({
        name: name,
        params: params,
        query: query
      });
    }
  },
  watch: {
    selectedStartDate(value) {
      this.startDate = value;
    },
    startDate() {
      this.selectedDatesAvailable = true;
    },
    endDate() {
      this.selectedDatesAvailable = true;
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/property-calendar/dialogs/EditEntryDialog.vue